
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6Htct", function(module, exports) {
var $4c47f75c6ef52bb8$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
var $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE"] = "jira-cmp-space-settings-people";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_VIEW"] = "jira-admin-permission-schemes-view";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_ADD"] = "jira-admin-permission-schemes-add";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_EDIT"] = "jira-admin-permission-schemes-edit";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_DELETE"] = "jira-admin-permission-schemes-delete";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["SAC"] = "sac";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
module.exports["HandleActionType"] = $4c47f75c6ef52bb8$export$87497e63e164f4b3;
module.exports["PageContextType"] = $4c47f75c6ef52bb8$export$7f7a6f1c2ab5127;

});

parcelRegister("jO3S6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $5eff64246cff89b2$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("23ga2")));
const $5eff64246cff89b2$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($5eff64246cff89b2$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        })
    });
});
module.exports["LazyAnimatedRovoIcon"] = $5eff64246cff89b2$export$7ea4e54699cd5224;

});

parcelRegister("23ga2", function(module, exports) {

let $17e865d2382724b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17e865d2382724b6$var$load("frhR0").then(()=>parcelRequire('5O8EX'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("cdw4J", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e1accb675e158e1c$var$animation = null;
const $e1accb675e158e1c$var$animation1 = null;
const $e1accb675e158e1c$var$animation2 = null;
const $e1accb675e158e1c$var$dot1 = null;
const $e1accb675e158e1c$var$dot2 = null;
const $e1accb675e158e1c$var$dot3 = null;
const $e1accb675e158e1c$var$animatedOpacity = null;
const $e1accb675e158e1c$export$c0e6915bcce7d1d0 = ({ isAnimated: isAnimated = true })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "10",
        height: "2",
        viewBox: "0 0 10 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v1gpk",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M0.0800781 2V0.414062H1.67969V2H0.0800781Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44v18gg",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M3.83984 2V0.414062H5.43945V2H3.83984Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gMc0m.default)([
                    isAnimated && "",
                    isAnimated && "_y44voqx9",
                    isAnimated && $e1accb675e158e1c$var$animatedOpacity
                ]),
                d: "M7.59961 2V0.414062H9.19922V2H7.59961Z",
                fill: "#FCA700"
            })
        ]
    });
};
module.exports["EllipsesAnimation"] = $e1accb675e158e1c$export$c0e6915bcce7d1d0;

});

parcelRegister("gmO0J", function(module, exports) {
$parcel$export(module.exports, "RovoThinkingIndicator", () => (parcelRequire("6jnYQ")).RovoThinkingIndicator);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $hezkK = parcelRequire("hezkK");


var $hQeYQ = parcelRequire("hQeYQ");


var $aisF3 = parcelRequire("aisF3");


var $6jnYQ = parcelRequire("6jnYQ");

const $185ac8354d914567$var$isForgeAgent = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $185ac8354d914567$var$styles = {
    container: "",
    stepContainerWithIndicator: "_18u01jfw",
    stepContainerWithoutIndicator: "_18u0u2gc"
};
const $185ac8354d914567$var$ExpandableTrace = ({ trace: trace, isLastItem: isLastItem, placeholder: placeholder = false })=>{
    const { title: title, defaultExpanded: defaultExpanded = false, content: content = null, status: status } = trace;
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(defaultExpanded);
    const setIsExpandedValue = (0, $42omo.useCallback)(()=>{
        setIsExpanded((prev)=>!prev);
    }, [
        setIsExpanded
    ]);
    const commonProps = {
        title: title,
        isLastItem: isLastItem,
        status: status
    };
    return content ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hQeYQ.ExpandableLoadingStep), {
        isExpanded: isExpanded,
        onClick: setIsExpandedValue,
        ...commonProps,
        children: content
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $aisF3.LoadingStep), {
        ...commonProps,
        placeholder: placeholder
    });
};
const $185ac8354d914567$export$1e7724c434f1ba76 = ({ traces: traces, disableAnimation: disableAnimation, agent: agent, hideThinkingIndicator: hideThinkingIndicator = false, ...props })=>{
    const thinkingText = props.thinkingText ?? '';
    const agentAvatarOrHiddenOrDefault = agent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: $185ac8354d914567$var$isForgeAgent(agent),
        forgeAgentIconUrl: agent.icon
    }) : !(0, $dh538.fg)('rovo_td_compact_cot_master_gate');
    const needsPlaceholder = traces?.some((t)=>t.content);
    const showThinkingIndicator = props.thinkingText && !hideThinkingIndicator;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $185ac8354d914567$var$styles.container,
        children: [
            showThinkingIndicator ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6jnYQ.RovoThinkingIndicator), {
                title: thinkingText,
                isAnimated: !disableAnimation,
                icon: agentAvatarOrHiddenOrDefault
            }) : null,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: (0, $1Whri.cx)(!!showThinkingIndicator ? $185ac8354d914567$var$styles.stepContainerWithIndicator : $185ac8354d914567$var$styles.stepContainerWithoutIndicator),
                children: traces ? traces.map((trace, i)=>{
                    const isLastItem = i === traces.length - 1;
                    return /*#__PURE__*/ (0, $l998X.jsx)($185ac8354d914567$var$ExpandableTrace, {
                        trace: trace,
                        isLastItem: isLastItem,
                        placeholder: needsPlaceholder
                    }, `${trace.title}-${trace.status}`);
                }) : null
            })
        ]
    });
};
module.exports["MessageLoading"] = $185ac8354d914567$export$1e7724c434f1ba76;

});

parcelRegister("hQeYQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $g9Srd = parcelRequire("g9Srd");

var $fT2ta = parcelRequire("fT2ta");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $aisF3 = parcelRequire("aisF3");


var $cqWxz = parcelRequire("cqWxz");

const $a05558c6f615f8ad$var$styles = {
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1qi0 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _1bsb1osq _bfhk1j28 _y3gn1e5h",
    expandablePressable: "_v564mfn2 _1tkezwfg _irr31dpa _d0altlke",
    chevronContainer: "_2hwxu2gc",
    expandedContent: "_1bsb1osq _ca0qu2gc _u5f3u2gc _n3td1b66 _19bvu2gc _1nmz1hna"
};
const $a05558c6f615f8ad$export$aa6e6454f6f47e48 = ({ title: title, onClick: onClick, testId: testId = 'rovo-expandable-step', isExpanded: isExpanded = false, isLastItem: isLastItem = false, status: status, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $aisF3.LoadingStepContainer), {
        testId: testId,
        status: status,
        isLastItem: isLastItem,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                xcss: (0, $1Whri.cx)($a05558c6f615f8ad$var$styles.titleContainer, $a05558c6f615f8ad$var$styles.expandablePressable),
                testId: testId,
                onClick: onClick,
                "data-expanded": isExpanded,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aisF3.LoadingStepTitle), {
                            title: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $a05558c6f615f8ad$var$styles.chevronContainer,
                        children: isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            label: formatMessage((0, $cqWxz.default).collapseIconLabel),
                            size: "small",
                            color: "var(--ds-icon-subtle, #505258)"
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                            label: formatMessage((0, $cqWxz.default).expandIconLabel),
                            size: "small",
                            color: "var(--ds-icon-subtle, #505258)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
                children: isExpanded && /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                    entranceDirection: "top",
                    exitDirection: "top",
                    duration: "medium",
                    children: (motionProps)=>{
                        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ...motionProps,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $a05558c6f615f8ad$var$styles.expandedContent,
                                children: children
                            })
                        });
                    }
                })
            })
        ]
    });
};
module.exports["ExpandableLoadingStep"] = $a05558c6f615f8ad$export$aa6e6454f6f47e48;

});

parcelRegister("aisF3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $fT2ta = parcelRequire("fT2ta");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $ksLgp = parcelRequire("ksLgp");

const $e87a3f4b795675a6$var$styles = {
    root: "_11c82smr _1bsb1osq _gy1p1b66 _1bah1y6m _syazazsu",
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rko1qi0 _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qu2gc _u5f3u2gc _19bvu2gc _n3tdu2gc",
    iconContainer: "_ca0qu2gc _19pkv77o _1e0c1txw _2lx21bp4",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4",
    verticalRule: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsbidpf _1tke1crf _1e0c1txw _18u0u2gc _2hwxu2gc _19pku2gc",
    loadingStepIconPlaceholder: "_1bsbgktf"
};
const $e87a3f4b795675a6$export$6e706d1f753e28ed = ({ testId: testId, children: children, xcss: xcss, status: status, isLastItem: isLastItem })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($e87a3f4b795675a6$var$styles.root, xcss),
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $e87a3f4b795675a6$var$styles.iconContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ksLgp.StatusIndicator), {
                        status: status
                    }),
                    !isLastItem && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $e87a3f4b795675a6$var$styles.verticalRule
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $e87a3f4b795675a6$var$styles.contentContainer,
                children: children
            })
        ]
    });
};
const $e87a3f4b795675a6$export$179b516a1b61c27 = ({ title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $e87a3f4b795675a6$var$styles.titleContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "medium",
            color: "color.text.subtle",
            children: title
        })
    });
};
const $e87a3f4b795675a6$export$ed7124825ced7ddc = ({ title: title, testId: testId = 'rovo-loading-step', isLastItem: isLastItem = false, status: status, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
        duration: "large",
        entranceDirection: "bottom",
        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...props,
                children: /*#__PURE__*/ (0, $l998X.jsx)($e87a3f4b795675a6$export$6e706d1f753e28ed, {
                    testId: testId,
                    status: status,
                    isLastItem: isLastItem,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)($e87a3f4b795675a6$export$179b516a1b61c27, {
                                title: title
                            }),
                            placeholder && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $e87a3f4b795675a6$var$styles.loadingStepIconPlaceholder
                            })
                        ]
                    })
                })
            })
    });
};
module.exports["LoadingStepContainer"] = $e87a3f4b795675a6$export$6e706d1f753e28ed;
module.exports["LoadingStepTitle"] = $e87a3f4b795675a6$export$179b516a1b61c27;
module.exports["LoadingStep"] = $e87a3f4b795675a6$export$ed7124825ced7ddc;

});

parcelRegister("ksLgp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $3gddQ = parcelRequire("3gddQ");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");


var $6DSrS = parcelRequire("6DSrS");


var $9hlns = parcelRequire("9hlns");


var $9Y4C8 = parcelRequire("9Y4C8");

const $ab83698aa24eebb9$export$b4f88f0ca5784eef = ({ status: status, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    switch(status){
        case 'loading':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "small",
                testId: testId,
                interactionName: "loading-status-indicator-spinner"
            });
        case 'success':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                label: formatMessage((0, $9Y4C8.default).success),
                size: "medium",
                color: "var(--ds-icon-success, #6A9A23)",
                testId: testId
            });
        case 'info':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: formatMessage((0, $9Y4C8.default).info),
                size: "medium",
                color: "var(--ds-icon-information, #357DE8)",
                testId: testId
            });
        case 'error':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage((0, $9Y4C8.default).error),
                size: "medium",
                color: "var(--ds-icon-danger, #C9372C)",
                testId: testId
            });
        case 'warning':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                label: formatMessage((0, $9Y4C8.default).warning),
                size: "medium",
                color: "var(--ds-icon-warning, #E06C00)",
                testId: testId
            });
        case 'discovery':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3gddQ))), {
                label: formatMessage((0, $9Y4C8.default).discovery),
                size: "medium",
                color: "var(--ds-icon-discovery, #AF59E1)",
                testId: testId
            });
        case 'to-do':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6DSrS))), {
                label: formatMessage((0, $9Y4C8.default).todo),
                size: "medium",
                testId: testId
            });
        // explicitly return nothing from default case.
        // This shouldn't happen since `status` is required, but it could if someone casts incorrectly or data is undefined from the server.
        default:
    }
};
module.exports["StatusIndicator"] = $ab83698aa24eebb9$export$b4f88f0ca5784eef;

});

parcelRegister("9Y4C8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a054a6fce392dfbb$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $a054a6fce392dfbb$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    success: {
        id: "ai-mate.loading-status-indicator.success",
        defaultMessage: "Success"
    },
    loading: {
        id: "ai-mate.loading-status-indicator.loading",
        defaultMessage: "Loading"
    },
    error: {
        id: "ai-mate.loading-status-indicator.error",
        defaultMessage: "Error"
    },
    info: {
        id: "ai-mate.loading-status-indicator.info",
        defaultMessage: "Information"
    },
    warning: {
        id: "ai-mate.loading-status-indicator.warning",
        defaultMessage: "Warning"
    },
    discovery: {
        id: "ai-mate.loading-status-indicator.discovery",
        defaultMessage: "Discovery"
    },
    todo: {
        id: "ai-mate.loading-status-indicator.todo",
        defaultMessage: "To do"
    }
});

});

parcelRegister("cqWxz", function(module, exports) {
$parcel$export(module.exports, "default", () => $83f7bd9d9dbbd64a$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $83f7bd9d9dbbd64a$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    expandIconLabel: {
        id: "ai-mate.chat-history.loading-state.expand-icon",
        defaultMessage: "Expand"
    },
    collapseIconLabel: {
        id: "ai-mate.chat-history.loading-state.collapse-icon",
        defaultMessage: "Collapse"
    }
});

});

parcelRegister("6jnYQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $cdw4J = parcelRequire("cdw4J");


var $jO3S6 = parcelRequire("jO3S6");

const $079af3e939037f4e$var$styles = {
    root: "_4t3i1tcg _1e0c1txw _2lx2vrvc _1bah1e5h _1n261g80 _4cvr1h6o",
    iconContainer: "_zulpu2gc _2hwxv77o _1e0c1txw _4cvr1h6o",
    text: "_11c82smr _16jlkb7n _1o9zkb7n _i0dlf1ug _syazi7uo _1nmz1hna",
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $079af3e939037f4e$var$getIcon = (icon)=>{
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(icon)) return icon;
    else if (icon) {
        if ((0, $dh538.fg)('platform_editor_ai_aifc_patch_ga')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jO3S6.LazyAnimatedRovoIcon), {
            alt: "Rovo",
            testId: "rovo-loading-animation",
            width: "24px",
            height: "24px"
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
            label: "",
            shouldUseHexLogo: true,
            size: "small"
        });
    }
    return null;
};
const $079af3e939037f4e$export$cc468b3595726b51 = ({ title: title, isAnimated: isAnimated = true, icon: icon = true, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $079af3e939037f4e$var$styles.root,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $079af3e939037f4e$var$styles.iconContainer,
                children: [
                    $079af3e939037f4e$var$getIcon(icon),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $079af3e939037f4e$var$styles.text,
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $079af3e939037f4e$var$styles.ellipsesContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdw4J.EllipsesAnimation), {
                    isAnimated: isAnimated
                })
            })
        ]
    });
};
module.exports["RovoThinkingIndicator"] = $079af3e939037f4e$export$cc468b3595726b51;

});

parcelRegister("i08Mr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $luTXj = parcelRequire("luTXj");

const $e459ef83dafb04f4$var$initialState = {
    fullScreen: false,
    externalEmbed: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true
    },
    // ChatRefreshV1Exp
    isRenderRefreshEnabled: false,
    isNewInputEnabled: false,
    isNewNavigationEnabled: false,
    isNewEmptyScreenEnabled: false,
    dynamicConfig: {
        rovoChatRefreshV2Config: (0, $luTXj.initialState)
    }
};
const $e459ef83dafb04f4$export$ab340e857ee89c62 = $e459ef83dafb04f4$var$initialState;
const $e459ef83dafb04f4$var$uiConfig = /*#__PURE__*/ (0, $42omo.createContext)($e459ef83dafb04f4$var$initialState);
const $e459ef83dafb04f4$export$3063519296e335bf = $e459ef83dafb04f4$var$uiConfig.Provider;
const $e459ef83dafb04f4$export$e83755c3ab7a4493 = ()=>(0, $42omo.useContext)($e459ef83dafb04f4$var$uiConfig);
const $e459ef83dafb04f4$export$3e623b13d2da727a = (config)=>{
    // Allow fullscreen override for branch deploy testing purposes
    const processedConfig = localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' && (0, $dh538.fg)('rovo_chat_show_local_frontend_components') ? {
        ...config,
        fullScreen: true
    } : config;
    const rovoChatRefreshV2Config = (0, $luTXj.getChatRefreshV2Config)();
    return {
        ...{
            ...$e459ef83dafb04f4$var$initialState,
            ...processedConfig,
            enableBrowserContextBanner: processedConfig?.enableBrowserContextBanner ?? $e459ef83dafb04f4$var$initialState.enableBrowserContextBanner,
            browserContextSanitizer: processedConfig?.browserContextSanitizer,
            elements: {
                ...$e459ef83dafb04f4$var$initialState.elements,
                ...processedConfig?.elements
            },
            promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls
        },
        isRenderRefreshEnabled: true,
        isNewInputEnabled: true,
        isNewNavigationEnabled: true,
        isNewEmptyScreenEnabled: true,
        dynamicConfig: {
            ...$e459ef83dafb04f4$var$initialState.dynamicConfig,
            rovoChatRefreshV2Config: {
                ...rovoChatRefreshV2Config
            }
        }
    };
};
module.exports["UIConfigProvider"] = $e459ef83dafb04f4$export$3063519296e335bf;
module.exports["useUIConfig"] = $e459ef83dafb04f4$export$e83755c3ab7a4493;
module.exports["createUIConfig"] = $e459ef83dafb04f4$export$3e623b13d2da727a;

});

parcelRegister("luTXj", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");

const $c3ee1b3abf16f6b9$export$d4c72bab9d6cc13a = {
    isMinimodalHeightAnimationEnabled: false,
    isDeepResearchEnabled: false,
    isNewMessagesEnabled: false,
    isNewMessagesActionsEnabled: false,
    isNewAllConversationScreenEnabled: false,
    isNewInputPromptTypeaheadEnabled: false,
    isReasoningOptionsV2Enabled: false,
    isReasoningStickyOptionEnabled: false,
    isPromptLibraryEnabled: false,
    isNewLoadingStateEnabled: false,
    isUpdatedAgentMenuDropdownEnabled: false,
    isSpinnerOverlayConversationIconEnabled: false
};
const $c3ee1b3abf16f6b9$export$7e5ffbab45e913e0 = ()=>{
    return {
        isMinimodalHeightAnimationEnabled: false,
        isDeepResearchEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isDeepResearchEnabled', false),
        isNewMessagesEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesEnabled', false),
        isNewMessagesActionsEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewMessagesActionsEnabled', false),
        isNewAllConversationScreenEnabled: false,
        isNewInputPromptTypeaheadEnabled: false,
        isDynamicStartersAPIEnabled: false,
        isReasoningOptionsV2Enabled: false,
        isReasoningStickyOptionEnabled: false,
        isPromptLibraryEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isPromptLibraryEnabled', false),
        isNewLoadingStateEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isNewLoadingStateEnabled', false),
        isUpdatedAgentMenuDropdownEnabled: (0, $c6GJD.default).getExperimentValue('rovo_chat_refresh_v2_experiment', 'isUpdatedAgentMenuDropdownEnabled', false),
        isSpinnerOverlayConversationIconEnabled: false
    };
};
module.exports["initialState"] = $c3ee1b3abf16f6b9$export$d4c72bab9d6cc13a;
module.exports["getChatRefreshV2Config"] = $c3ee1b3abf16f6b9$export$7e5ffbab45e913e0;

});


//# sourceMappingURL=CommentsPanelFilterMenu.ae00267d.js.map
